import {
    selectChapters,
    selectContent,
    selectImageForPage,
    selectNextPage,
    selectPage,
    selectPrevPage,
    selectScaleCenter,
    selectZoomScale,
} from 'selectors/content';
import {
    isInstructorInSection,
    selectLastHighlightColor,
    hideSharingQA,
} from 'selectors/current_user';
import { isConnected } from 'selectors/offline';
import { selectVisibleHighlights } from 'selectors/markup';
import { selectSection } from 'selectors/section';

export default function engageReaderSelector(state, props) {
    // Routes only have strings :(
    const contentId = parseInt(props.params.contentId, 10);
    const pagenum = parseInt(props.params.pagenum, 10);

    const content = selectContent(state, contentId);
    const section = selectSection(state, content.section_id);
    const page = selectPage(state, content, pagenum);

    return {
        chapters: selectChapters(state, content),
        content,
        contentId,
        hideSharingQA: hideSharingQA(state),
        highlights: selectVisibleHighlights(state, content, pagenum),
        imgsrc: selectImageForPage(state, content, pagenum),
        isConnected: isConnected(state),
        isInstructor: isInstructorInSection(state, section),
        lastHighlightColor: selectLastHighlightColor(state),
        nextPage: selectNextPage(state, content, pagenum),
        page,
        pageLabel: page.label,
        pagenum,
        prevPage: selectPrevPage(state, content, pagenum),
        rootStateHack: state, // I hate this.
        scale: selectZoomScale(state, content, pagenum),
        scaleCenter: selectScaleCenter(state, content, pagenum),
        section,
    };
}



// WEBPACK FOOTER //
// ./src/selectors/component_selectors/engage_reader_selector.js